import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {environment} from "../../environments/environment";
import {PartnerShopOrderDgSearchResults} from "../models/datagrid-search-results/partner-shop-order.dg-search-results.model";
import {PartnerShopOrdersService} from "../providers/partner-shop-orders.service";

@Injectable()
export class PartnerShopOrderResolve implements Resolve<PartnerShopOrderDgSearchResults> {
  constructor(private partnerShopOrdersService: PartnerShopOrdersService, private appStateService: AppStateService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<PartnerShopOrderDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    return this.partnerShopOrdersService.getResults(environment.DEFAULT_RESULTS_LIMIT, 0, 'ASC', 'created').pipe(tap(res => {
      this.appStateService.updateIsBusySubject(false);
    }));
  }
}
